// extracted by mini-css-extract-plugin
export default {"customerParent":"CustomerMain_customerParent__jlOan","customerWrapper":"CustomerMain_customerWrapper__24orG"};